export const BillingRoutes = {
    GetBillingAccountById: "Billing/GetBillingAccountById",
    GetInspectionExistingBillingDetails: "Billing/GetInspectionExistingBillingDetails"
}